/** Same-origin collection pages only; labels always come from Shopify Liquid. */
export function findBreadcrumbCollection(links, referrer, origin) {
  if (!referrer) return;
  let previous;
  try { previous = new URL(referrer); } catch { return; }
  if (previous.origin !== origin) return;
  return links.find((link) => {
    let url;
    try { url = new URL(link.href, origin); } catch { return false; }
    const path = url.pathname.replace(/\/$/, '');
    const previousPath = previous.pathname.replace(/\/$/, '');
    if (url.origin !== origin || !/\/collections\/[^/]+$/.test(path)) return false;
    if (previousPath === path) return true;
    const suffix = previousPath.slice(path.length + 1);
    return previousPath.startsWith(`${path}/`) && suffix !== 'products' && !suffix.includes('/');
  });
}

export function breadcrumbData() {
  return {
    init() {
      const root = this.$el;
      if (root.hasAttribute('data-url-collection')) return;
      const template = root.querySelector('template[data-breadcrumb-collections]');
      if (!template) return;
      const collection = findBreadcrumbCollection([...template.content.querySelectorAll('a')], document.referrer, location.origin);
      if (!collection) return;
      const item = root.querySelector('[data-breadcrumb-collection]');
      if (!item) return;
      item.querySelector('a').replaceWith(collection.cloneNode(true));
      item.hidden = false;
      const index = root.querySelector('[data-breadcrumb-index]');
      if (index) index.hidden = false;
      if (root.hasAttribute('data-hide-product')) root.querySelector('[data-breadcrumb-current]').classList.add('volt-breadcrumbs__current--hidden');
    }
  };
}

let registered = false;
class VoltBreadcrumbs extends HTMLElement {
  connectedCallback() {
    this.events?.abort();
    const events = new AbortController();
    this.events = events;
    queueMicrotask(() => {
      if (events.signal.aborted || !this.isConnected) return;
      const attach = () => {
        if (!registered) { window.Alpine.data('voltBreadcrumbs', breadcrumbData); registered = true; }
        // Add only after registration. Alpine owns initialization and removal cleanup.
        this.setAttribute('x-data', 'voltBreadcrumbs');
      };
      if (window.Alpine) attach();
      else document.addEventListener('alpine:init', attach, { once: true, signal: events.signal });
    });
  }
  disconnectedCallback() { this.events?.abort(); }
}
if (!customElements.get('volt-breadcrumbs')) customElements.define('volt-breadcrumbs', VoltBreadcrumbs);
